module.exports = __webpack_public_path__ + "img/shake.e0dc33a0.svg";